// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-02beece5] {\n  color: #ed4014;\n}\n.table[data-v-02beece5]  .el-tooltip {\n  white-space: inherit !important;\n}\n.star[data-v-02beece5] .el-rate {\n  line-height: 2.2 !important;\n}\n.table[data-v-02beece5]  el-image__inner,\n.table .el-image__placeholder[data-v-02beece5],\n.table .el-image__error[data-v-02beece5] {\n  width: auto !important;\n}\n.info[data-v-02beece5] {\n  width: 82%;\n}", ""]);
// Exports
module.exports = exports;
